import type { PartSvgProps } from './types'

export default function AkBayonetLugSvg ({
  fill = 'var(--gs-part-fill,   #2A2A3A)',
  stroke = 'var(--gs-part-stroke, #5A6A7A)',
  width = 60,
  height = 50
}: PartSvgProps) {
  return (
    <svg viewBox="0 0 60 50" width={width} height={height} fill="none"
         xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="8" width="52" height="36" rx="3"
            fill={fill} stroke={stroke} strokeWidth="1.5" />
      <circle cx="30" cy="26" r="10" fill="#0A0D14" stroke={stroke} strokeWidth="1" />
    </svg>
  )
}
